export default function CtaBanner() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-primary-500 via-primary-400 to-accent-400 px-6 py-12 text-center md:px-12">
          <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full bg-background-50/10"></div>
          <div className="pointer-events-none absolute -bottom-10 -left-10 h-48 w-48 rounded-full bg-background-50/10"></div>
          <h2 className="relative font-heading text-2xl text-background-50 md:text-4xl">
            从女主是谁开始，一起看懂泡在我家的辣妹
          </h2>
          <p className="relative mx-auto mt-3 max-w-xl text-sm text-background-50/90 md:text-base">
            角色介绍、人物关系、角色图鉴都已整理好，现在就从上往下翻一遍，直接入坑不再迷茫。
          </p>
          <div className="relative mt-6 flex flex-wrap justify-center gap-3">
            <a
              href="#female-lead"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm text-primary-700 transition-colors hover:bg-background-100"
            >
              开始浏览
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}